/**
 * Public entry point for the shortcut system.
 *
 * Importing anything from here installs the bindings as a side effect, so
 * `shortcutLabel` is always answering from a populated registry — including on
 * the first render of a menu, before any effect has run.
 */
import "./bindings";

export { formatKeys, isApplePlatform } from "./keys";
export {
  getAllBindings,
  getBinding,
  getBindings,
  getProseMirrorBindings,
  register,
  shortcutLabel,
  unregister,
} from "./registry";
export { getActiveEditor } from "./activeEditor";
export { SHORTCUT_EVENTS } from "./events";
export { useShortcut } from "./useShortcut";
export type { Binding, Scope, ShortcutContext } from "./types";
